import { Controller } from "@hotwired/stimulus"

// Opens the shared #image-picker-modal (image-library) for one field.
// mode "snippet": insert <figure class="c-image"> at the cursor (HTML fields);
// mode "url": put the image URL into the field (deck back image / face icon).
export default class extends Controller {
  static targets = ["source"]
  static values = { mode: { type: String, default: "snippet" } }

  open(event) {
    event.preventDefault()
    this.dispatch("open", { target: window, detail: { field: this.sourceTarget, mode: this.modeValue } })
  }
}
